<template>
    <div
        v-if="!loading"
        class="h-100">
        <code-set-table
            :code-set="codeSet"
            @rowcount="codeCount = $event"
            @export-cols="exportColumns = $event"
            @refresh="loadCodeSet" />
    </div>
</template>

<script setup>
    import CodeSetTable from './CodeSetTable.vue';
    import { getLibraryFromCodeSet } from '@/shared/helpers/api';
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import { http } from '@/shared/httpWrapper.js';

    const loading = ref(true);
    const codeCount = ref(0);
    const codeSet = ref(null);
    const exportColumns = ref([]);

    const route = useRoute();

    async function loadCodeSet() {
        const codeSetName = route.params.codeSetName;
        codeSet.value = await getLibraryFromCodeSet(http, codeSetName);
        document.title = codeSet.value.description;
    }

    onMounted(async () => {
        await loadCodeSet();
        loading.value = false;
    });
</script>
